import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { FaturaModalProvider } from "./context/FaturasModal";
import { CustomizacaoOptionsProvider } from "./context/CustomizacaoOptions";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <FaturaModalProvider>
      <CustomizacaoOptionsProvider>
        <App />
      </CustomizacaoOptionsProvider>
    </FaturaModalProvider>
  </React.StrictMode>
);
